import { render, staticRenderFns } from "./Addresslistsimple.vue?vue&type=template&id=02799e83&scoped=true"
import script from "./Addresslistsimple.vue?vue&type=script&lang=js"
export * from "./Addresslistsimple.vue?vue&type=script&lang=js"
import style0 from "./Addresslistsimple.vue?vue&type=style&index=0&id=02799e83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02799e83",
  null
  
)

export default component.exports